import ChangePasswordImage from "assets/change-pass.png";
import { Card, CardContent, Grid, Typography } from "@mui/material";

// Static vars

const CHANGE_PASSWORD_SUCCESS_LABEL = "La contraseña se ha cambiado con éxito.";

/**
 * Component to render update password success container
 */

export const ChangePasswordSuccess = () => {
  return (
    <Grid container spacing={2}
      sx={{ paddingTop: '2rem' }}
      alignItems="center"
      justifyContent="center">

      <Grid item xs={12} sm={8} lg={4} >
        <Card>
          <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <Typography variant="h3" sx={{ textAlign: 'center', marginBottom: '2rem', fontSize: "30px" }}>
              {CHANGE_PASSWORD_SUCCESS_LABEL}
            </Typography>
            <img
              src={ChangePasswordImage}
              height={200}
              alt='Password cambiada'
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};